
var pc = pc || {};

(function (app) {
    app.classes = {
        current: 'current',
        hidden: 'is-hidden',
        transition: 'has-transition'
    };

    app.namespace = 'pc';

    app.events = {
        click: 'click.' + app.namespace
    };

    app.$objs = {};
    app.modules = [];
    app.parsley = $('.form').parsley({
        classHandler: function (el) {
            return el.$element.closest(".input")
        },
    });

    app.plugged = [
        { func: 'collapsible', target: '.collapsible', params: { closeSiblings: true } },
        { func: 'tabview', target: '.tab-view' }
    ];

    var mediaScreen = window.matchMedia("(max-width: 992px)")
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);

    var listBoxArr = [];

    function ValidateIPaddress(ipaddress) {
        if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
            return (true)
        }
        return (false)
    }

    app.parsleyButton = function () {
        if ($('.form').length > 0) {
            $('.input input').on('keydown paste', function () {
                setTimeout(() => {
                    if ($(this).closest('form').parsley().isValid()) {
                        $('.form__action .button').attr('disabled', false);
                        $('.form__action .button').removeClass("button--disabled");
                    } else {
                        $('.form__action .button').attr('disabled', true);
                        $('.form__action .button').addClass("button--disabled");

                    }
                }, 200)
            })
        }
    }

    app.onPasswordToggle = function () {
        $('.js-button-toggle-password').click(function (e) {
            var input = $(this).closest('.input').find('input');

            e.preventDefault();
            if (input.attr('type') == 'password') {
                input.attr('type', 'text');
            } else {
                input.attr('type', 'password');
                $(this).removeClass('visible');
            }

            $(this).find("i").toggleClass("icon-visible icon-hidden")
        })
    }

    app.onSelect = function () {

        $('.select select').select2({
            minimumResultsForSearch: Infinity
        });

        $('.select--multiple select').select2({
            closeOnSelect: false
        });

        $('.select select').on('change', function () {
            $(this).attr('data-dirty', true);
        });

        $(".js-select-custom-width-300").on('select2:open', function (e) {
            $('body').find('span.select2-dropdown--below').addClass('custom-width-300');
            $('body').find('ul.select2-results__options').addClass('custom-width-300');
        });

        $('.select--with-search').on('select2:open', function (e) {
            $('body').find(".select2-search").addClass("d-block").find("input").attr("placeholder", "Listede ara");
        });

        $('.js-has-dataUrl').find("select").change(function () {
            let dataUrl = $(this).find(":selected").attr("data-url");
            let selectName = $(this).attr("name")
            urlParams.set(selectName, dataUrl);
            history.replaceState(null, null, "?" + urlParams.toString());
            location.reload();
        });

        if ($('.js-has-dataUrl')) {
            // const selectName = $('.js-has-dataUrl select').attr("name")
            // const status = urlParams.get(selectName);
            var selectList = $('.js-has-dataUrl');
            selectList.each(function () {
                var selectName = $(this).find("select").attr("name");
                var status = urlParams.get(selectName);

                if (status) {
                    $(this).find("select").val(status).select2({
                        minimumResultsForSearch: Infinity
                    })
                }
            })
        }
    }

    app.onFileUpload = function () {
        $('.input__file input').on("change", function () {
            var input = $(this);
            var inputParent = $(this).closest(".input__file")
            var inputVal = input.val().split("\\");
            var lastEl = inputVal[inputVal.length - 1];
            inputParent.find(".js-filename").text(lastEl);

            inputParent.find(".input__icon")
                .addClass("input__icon--accessible js-delete-file")
                .find("i")
                .toggleClass("icon-file-select icon-close");

            if (input.hasClass("parsley-error")) {
                inputParent.addClass("parsley-error")
            }
        });

        $('.input').on("click", ".js-delete-file", function () {
            var elParent = $(this).closest(".input");
            elParent
                .find("input")
                .attr("data-dirty", "false")
                .val("");
            elParent
                .find(".input__filename")
                .text("")
            $(this)
                .removeClass("input__icon--accessible js-delete-file")
                .find("i")
                .toggleClass("icon-file-select icon-close");
        });


        window.Parsley
            .addValidator('fileextension', function (value, requirement) {
                var fileExtension = value.split('.').pop();
                return fileExtension.toLowerCase() === requirement.toLowerCase();
            }, 32)
            .addMessage('en', 'fileextension', 'The extension doesn\'t match the required');
    }

    app.onDatepicker = function () {

        var date = new Date(), y = date.getFullYear(), m = date.getMonth();

        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);
        let getDefaultDate = ["01.12.2024", "04.12.2024"];

        flatpickr('#date-range', {
            mode: "range",
            showMonths: mediaScreen.matches ? 1 : 2,
            monthSelectorType: "static",
            yearSelectorType: "static",
            dateFormat: "d.m.Y",
            "locale": "tr",
            onClose: function (selectedDates, dateStr, instance) {
                let $this = $(instance.element)
                if ($this.parent().has(".js-urlparams-operation")) {
                    let inputVal = $this.val();
                    if (inputVal == "") return;
                    let inputName = $this.attr("name")
                    urlParams.set(inputName, inputVal.replaceAll(" - ", "-"));
                    history.replaceState(null, null, "?" + urlParams.toString());
                    location.reload();
                }
            },
            onReady: function (selectedDates, dateStr, instance) {
                let $this = $(instance.element);
                if ($this.parent().has(".js-urlparams-operation")) {
                    const inputName = $this.attr("name");
                    const value = urlParams.get(inputName);
                    const splitFullDate = value.split("-");
                    const splitFirstDate = splitFullDate[0].split(".")[1];
                    const splitSecondDate = splitFullDate[1].split(".")[1];
                    if (value) {
                        instance.setDate(value.split("-"));
                        if (splitFirstDate != splitSecondDate) {
                            instance.changeMonth(-1);
                        }
                    }
                }
            },


        });

        flatpickr('#date', {
            showMonths: 2,
            monthSelectorType: "static",
            yearSelectorType: "static",
            dateFormat: "d.m.Y",
            "locale": "tr",
            onClose: function (selectedDates, dateStr, instance) {
                let $this = $(instance.element)
                if ($this.parent().has(".js-urlparams-operation")) {
                    let inputVal = $this.val();
                    let inputName = $this.attr("name")
                    urlParams.set(inputName, inputVal.replaceAll(" - ", "-"));
                    history.replaceState(null, null, "?" + urlParams.toString());
                    location.reload();
                }
            },
            onReady: function (selectedDates, dateStr, instance) {
                let $this = $(instance.element)
                if ($this.parent().has(".js-urlparams-operation")) {
                    const inputName = $this.attr("name");
                    const value = urlParams.get(inputName);

                    if (value) {
                        $this.val(value.replace("-", " - ")).attr("data-dirty", true)
                    }
                }
            }

        });
    }

    app.inputPassword = function () {
        $('#input-register-password').on('keyup', function () {
            var parsley_message_password_uppercase_message = "Your password must contain at least (%s) uppercase letter.";
            var parsley_message_password_lowercase_message = "Your password must contain at least (%s) lowercase letter.";
            var parsley_message_password_number_message = "Your password must contain at least (%s) number.";
            var parsley_message_password_special_message = "Your password must contain at least (%s) special characters.";

            window.Parsley.addValidator('uppercase', {
                requirementType: 'number',
                validateString: function (value, requirement) {
                    var uppercases = value.match(/[A-ZŞÜÇÖİĞ]/g) || [];
                    return uppercases.length >= requirement;
                },
                messages: {
                    en: parsley_message_password_uppercase_message
                }
            });

            window.Parsley.addValidator('lowercase', {
                requirementType: 'number',
                validateString: function (value, requirement) {
                    var lowecases = value.match(/[a-zşüçöiğ]/g) || [];
                    return lowecases.length >= requirement;
                },
                messages: {
                    en: parsley_message_password_lowercase_message
                }
            });

            window.Parsley.addValidator('number', {
                requirementType: 'number',
                validateString: function (value, requirement) {
                    var numbers = value.match(/[0-9]/g) || [];
                    return numbers.length >= requirement;
                },
                messages: {
                    en: parsley_message_password_number_message
                }
            });

            window.Parsley.addValidator('special', {
                requirementType: 'number',
                validateString: function (value, requirement) {
                    var specials = value.match(/[^a-zA-Z0-9şŞüÜçÇöÖıİğĞ]/g) || [];
                    return specials.length >= requirement;
                },
                messages: {
                    en: parsley_message_password_special_message
                }
            });
        })

        $('.input--password .input__icon').on('click', function (e) {
            var input = $(this).closest('.input').find('input');

            e.preventDefault();
            if (input.attr('type') == 'password') {
                input.attr('type', 'text')
                $(this).addClass('visible')
            } else {
                input.attr('type', 'password')
                $(this).removeClass('visible')
            }
        })

        if ($('.js-password').length > 0) {
            $('.js-password input').parsley().on('field:success', function (e) {
                $('.js-password .password-hint, .js-password .input--password').addClass('valid');
            });
        }
    }

    app.onInput = function () {
        $('.input input, .textarea textarea').on('change', function () {
            $(this).attr('data-dirty', true);
        });

        $('.input input').each(function () {
            if ($(this).val().length > 1) {
                $(this).attr('data-dirty', true);
            }
        })

        $('.input input[type = "email"]').on('keypress', function (event) {
            const keyCode = event.charCode || event.keyCode;
            const targetVal = $(event.target).val();
            if (targetVal) {
                return ! /^['"!#$%>(&)*<+/=?^`{|}~:;,çÇğĞıİöÖşŞüÜ ]*$/.test(String.fromCharCode(keyCode));
            } else {
                return ! /^[-'"!#$%>._(&)*<+/=?^`{|}~:;,çÇğĞıİöÖşŞüÜ ]*$/.test(String.fromCharCode(keyCode));
            }
        });

        $('.js-input-number').on("keydown", function (e) {
            if (e.keyCode == 69 || e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 189) {
                e.preventDefault();
            }
        });

        $('.js-urlparams-operation').change(function (e) {
            if ($(this).parent().hasClass("datepicker")) return;
            let inputVal = $(this).find("input").val();
            let inputName = $(this).find("input").attr("name");
            urlParams.set(inputName, inputVal);
            history.replaceState(null, null, "?" + urlParams.toString());
            location.reload();
        });
        if ($('.js-urlparams-operation')) {
            var inputList = $('.js-urlparams-operation');
            inputList.each(function () {
                if ($(this).parent().hasClass("datepicker")) return;
                var inputName = $(this).find("input").attr("name");
                var status = urlParams.get(inputName);

                if (status) {
                    $(this).find("input").val(status).attr("data-dirty", true)
                }
            })
        }
    };

    app.onSubMenu = function () {
        $('.has-submenu').click(function (e) {
            e.preventDefault();
            $(this).parent().toggleClass("active");
            $(this).next().toggleClass("active");
        })
    }

    app.onMobileOpener = function () {
        $('.js-button-menu-opener').click(function () {
            $('aside').toggleClass("mobile-active")
        })
    }

    app.onIPMask = function () {
        $(document).ready(function () {
            $('.js-ip-address').mask('999.999.999.999');
            // $('.js-ip-address').attr("pattern", "/(([0-1]?[0-9]{1,2}\.)|(2[0-4][0-9]\.)|(25[0-5]\.)){3}(([0-1]?[0-9]{1,2})|(2[0-4][0-9])|(25[0-5]))/");
            $('.js-ip-address').attr("data-parsley-validation-threshold", "20");
            $('.js-ip-address').on("keydown", function (e) {
                if (e.keyCode == 13) {
                    if ($('.js-button-add').length > 0) {
                        e.preventDefault();
                        $('.js-button-add').trigger("click")
                    }
                }
            });
        });
    }

    app.onAddList = function () {

        $(document).ready(() => {
            if ($('.js-list-box-is-empty').length == 0) {
                $('.js-list-box-is-empty').show();
            } else {
                $('.js-list-box-is-empty').hide();
            }
        });

        function addListTemplate(value) {
            return `<div class="list-box__item"><input type="checkbox" hidden="" id="${value}" value="${value}" name="${value}" /><label for="${value}">${value}</label></div>`
        }

        function addListWithRemoveTemplate(value) {
            return `<div class="list-box__item"><label>${value}</label><button class="list-box__remove-button js-button-list-box-removable"><i class="icon-minus"></i></button></div>`
        }

        function isEmptyList() {
            return `<div class="list-box__is-empty js-list-box-is-empty">Eklenecek IP Adresleri</div>`
        }

        function addListButtonChecker(wrapper) {
            if (wrapper.find(".list-box__item").length > 0) {
                wrapper.closest("form").find("button[type=submit]").prop("disabled", false).removeClass("button--disabled");
                $('.js-list-box-is-empty').remove();

            } else {
                wrapper.closest("form").find("button[type=submit]").prop("disabled", true).addClass("button--disabled")
                if (wrapper.find(".list-box__is-empty").length == 0) {
                    wrapper.append(isEmptyList());
                }
            }
        }
        $('.js-button-add').click(function (e) {
            e.preventDefault();

            let inputParent = $(this).closest("div");
            let input = inputParent.find("input");
            let inputVal = input.val();
            let inputHref = input.attr("data-href");
            let getTargetEl = $(`div[data-target=${inputHref}]`);
            let isIpValid;

            if (inputVal == "") {
                return;
            }

            if (input.hasClass("js-ip-address")) {
                if (ValidateIPaddress(inputVal)) {
                    isIpValid = true
                } else {
                    isIpValid = false
                }
            }


            if (listBoxArr.includes(inputVal) || !isIpValid) {
                var errorMessage = input.attr("custom-error-message");
                inputParent.addClass("parsley-error");

                if (inputParent.hasClass("parsley-error") && inputParent.find(".parsley-errors-list").length == 0) {
                    inputParent.append(`<ul class="parsley-errors-list filled" aria-hidden="false"><li class="parsley-required">${errorMessage}</li></ul>`)
                }
                return;
            } else {
                inputParent.removeClass("parsley-error");
                inputParent.find(".parsley-errors-list").remove();
                listBoxArr.push(inputVal);
            }

            if (getTargetEl.hasClass("list-box__removable")) {
                setTimeout(() => {
                    addListButtonChecker(getTargetEl);
                }, 300)

                if (input.parsley().isValid()) {
                    getTargetEl.prepend(addListWithRemoveTemplate(inputVal));
                    input.val("").attr("data-dirty", "false").removeClass("parsley-error");
                    input.next(":not(label)").hide();
                } else {
                    input.addClass("parsley-error");
                }

            } else {
                if (input.parsley().isValid()) {
                    getTargetEl.prepend(addListTemplate(inputVal));
                    input.val("").attr("data-dirty", "false").removeClass("parsley-error");
                    input.next(":not(label)").hide();
                } else {
                    input.addClass("parsley-error");
                }
            }


            $(`input[data-target-input=${inputHref}]`).val(listBoxArr);
        });

        $('.list-box__removable').on("click", ".js-button-list-box-removable", function () {
            var wrapper = $(this).closest(".list-box__removable")
            let closestDiv = $(this).closest("div");
            const input = $('#hidden-ip-list');
            let index = listBoxArr.indexOf($(this).prev().text());

            listBoxArr.splice(index, 1);
            input.val(listBoxArr);

            closestDiv.remove();

            addListButtonChecker(wrapper);
        });

        $('.list-box__removable').each(function () {
            if ($(this).find(".list-box__item").length > 0) {
                $(this).closest("form").find("button[type=submit]").prop("disabled", false).removeClass("button--disabled")
            }
        })
    }

    app.onImportExcel = function () {
        var ExcelToJSON = function (fileName) {
            var fileName = fileName;

            function addExcelValue(value) {
                return `<b>${fileName}</b> (${value} IP Adresi) <button class="js-button-empty-input"><i class="icon-close"></i></button>`
            }

            this.parseExcel = function (file) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var workbook = XLSX.read(data, {
                        type: 'binary'
                    });
                    workbook.SheetNames.forEach(function (sheetName) {
                        var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                        var json_object = JSON.stringify(XL_row_object);
                        $('.input__upload span').html(addExcelValue(JSON.parse(json_object).length));
                        if (JSON.parse(json_object).length > 0) {
                            $('.input__upload').closest("form").find("button[type=submit]").prop("disabled", false).removeClass("button--disabled")
                        } else {
                            $('.input__upload').closest("form").find("button[type=submit]").prop("disabled", true).addClass("button--disabled")
                        }
                    })
                };

                reader.onerror = function (ex) {

                };

                reader.readAsBinaryString(file);
            };
        };

        function handleFileSelect(evt) {
            var files = evt.target.files; // FileList object
            var xl2json = new ExcelToJSON(evt.target.value.split(/(\\|\/)/g).pop());
            xl2json.parseExcel(files[0]);
        }

        $('#ice-aktar').on('change', handleFileSelect);

        $('.input__upload').on("click", ".js-button-empty-input", function () {
            $(this).closest("span").html("Excel Dosyasını Seçin");
            $('.input__upload').closest("form").find("button[type=submit]").prop("disabled", true).addClass("button--disabled");
        });

    }

    app.onRemoveList = function () {
        $('.js-button-remove').click(function (e) {
            e.preventDefault();
            let closestDiv = $(this).closest("div");
            const input = $('#hidden-ip-list');
            let index = listBoxArr.indexOf(closestDiv.find("input:checked").val());

            listBoxArr.splice(index, 1);
            input.val(listBoxArr);

            closestDiv.find("input:checked").parent().remove();
        })
    }

    app.onProgress = function () {
        $('.progress__circle').circleProgress({
            value: 0.75,
            size: 40,
            fill: "#0d4ba0"
        });

        $('.js-button-progress-remove').click(function () {
            $(this).closest(".progress").fadeOut();
        })
    }

    app.onNotification = function () {
        $('.js-button-notification-remove').click(function () {
            $(this).closest(".notification").fadeOut();
        })
    }

    window.modalOpen = function (modalId, data, modalAttrs) {
        data.map((item) => {
            $(item.key).html(item.value)
        })

        $.fancybox.open($('#' + modalId), {
            modalAttrs
        });

        // $.fancybox.open($('#modal-custom-close-action'), {
        //     beforeClose: function () {
        //         alert("Kapanıyor")
        //     },
        //     afterClose: function () {
        //         alert("Kapandı")
        //     },
        // });
    }

    app.modals = function () {
        $('.modal .modal-button-accept').on('click', function () {
            $(this).closest('body').find('.checkbox .modal-checkbox input').prop('checked', true);
            $.fancybox.close();
        });
        $('.modal .modal-button-cancel').on('click', function () {
            $(this).closest('body').find('.checkbox .modal-checkbox input').prop('checked', false);
            $.fancybox.close();
        });

        if ($('.modal-wrapper').length > 0) {
            $.fancybox.open($('#test-modal-2'), {
                touch: false
            });
        }

        $('.js-open-modal').click(function () {
            var dataModal = $(this).attr("data-modal");
            $.fancybox.open($(`#${dataModal}`));
        })

    }

    app.onDropdown = function () {
        $('.js-button-dropdown').click(function (e) {
            e.stopPropagation();
            if ($(this).hasClass("active")) {
                $('.js-button-dropdown').removeClass("active");
                $('.js-button-dropdown').find("div").fadeOut();
            } else {
                $('.js-button-dropdown').removeClass("active");
                $('.js-button-dropdown').find("div").fadeOut();
                $(this).find("div").fadeIn();
                $(this).addClass("active");
            }

            if (mediaScreen.matches && $(this).closest("td")) {
                $(".js-button-dropdown").closest("td").removeClass("z-9")
                $(this).closest("td").toggleClass("z-9")
            }

            if ($(this).closest("tr")) {
                $(this).closest("table").find("tbody tr").removeClass("active")
                $(this).closest("tr").addClass("active");
            } else if ($(this).closest("tr").hasClass("active")) {
                $(this).closest("tr").removeClass("active");
            } else {
                return;
            }
        });

        $(document).click(function () {
            $('.js-button-dropdown').removeClass("active");
            $('.js-button-dropdown').find("div").fadeOut();
            $('.table tr').removeClass("active");
        });
    }


    app.onButtons = function () {
        $('.js-button-refresh').click(function () {
            location.reload()
        })
    }

    app.onInputCollapsible = function () {
        $('.js-input-collapse').click(function (e) {
            e.stopPropagation();
            $(this).addClass("show");
        });

        if (mediaScreen.matches) {
            $('.js-input-collapse').addClass("show")
        }

        $('.js-input-collapse input').on("input", function (e) {
            if ($(this).val().length > 0) {
                $(this).closest("div").find("button").html("<i class='icon-close-20'></i>");
                $(this).closest("div").find("button").addClass("js-button-clear-input");
            } else {
                $(this)
                $(this).closest("div").find("button").removeClass("js-button-clear-input");
            }
        });

        $('.js-input-collapse').on("click", ".js-button-clear-input", function () {
            $(this).closest("div").find("input").val("").attr("data-dirty", "false");
            $(this).closest("div").find("button").html("<i class='icon-search-magnifier'></i>");
            $(this).closest("div").find("button").removeClass("js-button-clear-input");
        });

        $(document).click(function () {
            $('.js-input-collapse').removeClass("show");
            $('.js-input-collapse').find("button").html("<i class='icon-search-magnifier'></i>");
            $('.js-input-collapse').find("input").val("").attr("data-dirty", "false");
        });

        $('.js-search').submit(function (e) {
            e.preventDefault();
            let inputVal = $(this).find("input").val();
            let inputName = $(this).find("input").attr("name");
            urlParams.set(inputName, inputVal);
            history.replaceState(null, null, "?" + urlParams.toString());
            location.reload();
        });

        if ($('.js-search')) {
            const inputName = $('.js-search input').attr("name");
            const search = urlParams.get(inputName);

            if (search) {
                $('.js-input-collapse').addClass("show")
                $('.js-search input').val(search).attr("data-dirty", true)
            }
        }
    }

    app.initModules = function () {
        if (app.modules.length > 0) {
            app.modules.forEach(function (module) {
                if (typeof app[module] !== 'undefined' && !app[module].isInitialized()) {
                    app[module].init();
                }
            });
        }
    };

    app.onTableOperation = function () {

        let buttonTableRemove, buttonRemoveSelected = $('.js-button-remove-selected');
        $('#delete-confirmation button, #delete-confirmation--user button').click(function () {
            let buttonData = $(this).attr("data-button");

            if (buttonData == "confirm") {
                if (buttonTableRemove != undefined) {
                    buttonTableRemove.closest("tr").remove();
                } else if (buttonRemoveSelected) {
                    buttonRemoveSelected.closest(".table-area").find("tbody input:checked").closest("tr").remove();
                    buttonRemoveSelected.closest(".table-area").find(".js-ip-address-counter").text("0");
                    buttonRemoveSelected.addClass("d-none");
                }

            }
        });

        $('.js-button-table-remove').click(function (e) {
            $.fancybox.open($('#delete-confirmation'));
            let dataUrl = $(this).attr("data-url");
            $('.js-checked-list').val(dataUrl)
            buttonTableRemove = $(this);
        });

        $('.js-button-user-remove').click(function (e) {
            $.fancybox.open($('#delete-confirmation--user'));
            buttonTableRemove = $(this);
        });

        var checkedList = [];
        function updateCheckListInput() {
            $('.js-checked-list').val(checkedList);
        }

        $('.table-checkbox').each(function () {
            $(this).on("change", function () {
                var checkedInputLength = $(this).find("tbody input:checked").length;
                $(this).closest(".table-area").find(".js-ip-address-counter").text(checkedInputLength);

                if (checkedInputLength > 0) {
                    $(this).closest(".table-area").find('.js-button-select-checkbox').removeClass("d-none");
                } else {
                    $(this).closest(".table-area").find('.js-button-select-checkbox').addClass("d-none");
                }
            });
        });

        $('.js-checkbox-all-check').click(function () {
            var basePath = $(this).closest(".table").find("tbody input")
            if ($(this).prop("checked") == false) {
                basePath.prop("checked", false);
                checkedList = []
            } else {
                basePath.prop("checked", true);
                checkedList = [];
                for (let index = 0; index < basePath.length; index++) {
                    checkedList.push(basePath[index].value);
                }
            }

            updateCheckListInput();
        });

        $('.js-button-remove-selected').click(function () {
            $.fancybox.open($('#delete-confirmation'));
        });

        $('.js-single-checkbox input').change(function () {
            if ($(this).prop("checked")) {
                checkedList.push($(this).val());
            } else {
                var index = checkedList.indexOf($(this).val())
                checkedList.splice(index, 1)
            }
            updateCheckListInput();
        });
    };

    app.onTableTooltip = function () {

        function tooltipTemplate(value) {
            return `<div class="table__tooltip">${value}</div>`
        }

        $('body').on("mouseover touchstart", "td.tooltip i, td.mobil-tooltip i", function (e) {
            let tooltipText = $(this).closest(".tooltip, .mobil-tooltip").text();
            let tooltipPosition = $(this).offset();
            $("body").append(tooltipTemplate(tooltipText));
            $("body").find(".table__tooltip").css({
                transform: `translate(${tooltipPosition.left - 174 < 0 ? 20 : tooltipPosition.left - 174}px, ${tooltipPosition.top - 6}px)`
            });
        }).on("mouseleave touchend", ".table__tooltip", function () {
            $("body").find(".table__tooltip").remove();
        })
    };

    function allAreTrue(arr) {
        return arr.every(element => element === true);
    }

    app.onDynamicModal = function () {
        $('[data-modal=dynamic-modal]').click(function (event) {
            if ($(this).prop("tagName") == "A") {
                event.preventDefault();
            }

            var getModalUrl = $(this).attr("data-modal-url");
            var getParameters = $(this).attr("data-modal-get-parameters").split(",");
            var parametersNameValueList = [];
            var parametersIsValid = [];
            var fullLink = getModalUrl + "?";



            for (i = 0; i < getParameters.length; i++) {
                parametersNameValueList.push(
                    {
                        inputName: $(`${getParameters[i]}`).attr("name"),
                        inputValue: $(`${getParameters[i]}`).val(),
                        isValid: $(`${getParameters[i]}`).parsley().validate() == true ? true : false
                    }
                )
            }

            jQuery.map(parametersNameValueList, function (val, index) {
                fullLink += val.inputName + "=" + encodeURIComponent(val.inputValue) + "&";
                parametersIsValid.push(val.isValid);
            });

            if (allAreTrue(parametersIsValid)) {
                $.ajax({
                    method: "GET",
                    url: fullLink,
                    success: (data) => {
                        var dynamicModal = $('#dynamic-modal');
                        $.fancybox.open(dynamicModal);
                        dynamicModal.find(".modal__body").html(data);
                    }
                });
            } else {
                $('input[data-modal=dynamic-modal]').prop("checked", false)
                $('input[data-modal=dynamic-modal]').parsley().validate("error")
            }
        })
    }

    app.onLoginCookieOperation = function () {
        $('[data-save-to-cookie-params]').click(function () {
            var getSaveCookieParams = $(this).attr("data-save-to-cookie-params").split(",");
            var getSaveCookieTime = $(this).attr("data-save-to-cookie-duration-hours") / 24;
            var saveCookieKeyValueList = [];
            var parametersIsValid = [];

            if (!$(this).prop("checked")) {
                for (i = 0; i < getSaveCookieParams.length; i++) {
                    Cookies.remove($(`${getSaveCookieParams[i]}`).attr("data-cookie-key"))
                }
                return;
            }

            for (i = 0; i < getSaveCookieParams.length; i++) {
                saveCookieKeyValueList.push(
                    {
                        dataCookieKey: $(`${getSaveCookieParams[i]}`).attr("data-cookie-key"),
                        inputValue: $(`${getSaveCookieParams[i]}`).val(),
                        isValid: $(`${getSaveCookieParams[i]}`).parsley().validate() == true ? true : false,
                        isEncrypt: $(`${getSaveCookieParams[i]}`).attr("data-cookie-encrypt") == "true" ? true : false
                    }
                )
            }

            jQuery.map(saveCookieKeyValueList, function (val, index) {
                parametersIsValid.push(val.isValid);
            });

            if (allAreTrue(parametersIsValid)) {
                jQuery.map(saveCookieKeyValueList, function (val, index) {
                    Cookies.set(val.dataCookieKey,
                        val.isEncrypt ? btoa(val.inputValue) : val.inputValue,
                        { expires: getSaveCookieTime, secure: val.isEncrypt ? true : false })
                });
            } else {
                $('[data-save-to-cookie-params]').prop("checked", false)
            }
        });


        $(document).ready(function () {
            if ($(this).find("[data-save-to-cookie-params]").length > 0) {
                var getSaveCookieParams = $("[data-save-to-cookie-params]").attr("data-save-to-cookie-params").split(",");
                var savedCookieKeyValueList = [];
                var allValueIsTrue = []

                for (i = 0; i < getSaveCookieParams.length; i++) {
                    savedCookieKeyValueList.push(
                        {
                            dataCookieKey: $(`${getSaveCookieParams[i]}`).attr("data-cookie-key"),
                            dataCookieVal: Cookies.get($(`${getSaveCookieParams[i]}`).attr("data-cookie-key"))
                        }
                    )
                }

                if (savedCookieKeyValueList.length > 0) {
                    jQuery.map(savedCookieKeyValueList, function (val, index) {
                        allValueIsTrue.push(val.dataCookieVal != undefined ? true : false);
                        if (val.dataCookieVal == undefined) return;
                        var isEncrypt = $(`input[data-cookie-key=${val.dataCookieKey}]`).attr("data-cookie-encrypt");
                        var finalValue = isEncrypt == "true" ? atob(val.dataCookieVal) : val.dataCookieVal
                        $(`input[data-cookie-key=${val.dataCookieKey}]`).val(finalValue)
                        $(`input[data-cookie-key=${val.dataCookieKey}]`).attr("data-dirty", true);
                    });


                    if (allAreTrue(allValueIsTrue)) {
                        $('[data-save-to-cookie-params]').prop("checked", true);
                    }

                    if ($('form').parsley().isValid()) {
                        $('.form__action .button').attr('disabled', false);
                        $('.form__action .button').removeClass("button--disabled");
                    };
                }

            }
        })
    }

    app.onJSZip = function () {
        function htmlTableToExcel(type, tableId) {
            var data = document.getElementById(tableId);
            var excelFile = XLSX.utils.table_to_book(data, { sheet: "sheet1" });
            XLSX.write(excelFile, { bookType: type, bookSST: true, type: 'base64' });
            XLSX.writeFile(excelFile, 'mobil_imza_portal_table.' + type);
        }

        $('.js-button-export-xlsx-all-table').click(function () {
            let getDataHref = $(this).attr("data-href")
            htmlTableToExcel("xlsx", getDataHref);
        });

        $('.js-button-export-xlsx-partial-table').click(function () {
            let getDataHref = $(this).attr("data-href");
            let cloneTable = $(this).closest(".table-area").find("table").clone();
            cloneTable.addClass("hide");
            cloneTable.attr("id", getDataHref)
            cloneTable.find("td input:not(:checked)").closest("tr").remove();
            $("body").append(cloneTable);
            htmlTableToExcel("xlsx", getDataHref);
        });

    };

    app.onTabs = function () {
        $('.tabs').on("click", ".tabs__head a", function () {
            let getDataHref = $(this).attr("data-href");
            $(this).closest(".tabs").find(".tabs__head__item").removeClass("tabs__head__item--active");
            $(this).addClass("tabs__head__item--active");
            $(this).closest(".tabs").find(".tabs__content__item").removeClass("tabs__content__item--active");
            $(this).closest(".tabs").find(`.tabs__content__item[data-target=${getDataHref}]`).addClass("tabs__content__item--active");
        })
    }

    app.onPreventEmoji = function () {
        if ($('input.apIdValidation').length > 0) {
            $('input.apIdValidation').on("input", function () {
                $(this).val($(this).val().replace(/[^a-zA-Z0-9_:/?.]/gm, ''))
            })
        }


    }

    app.bindPlugins = function () {
        $(app.plugged).each(function () {
            var e = this,
                p;

            if (typeof $.fn[e.func] !== 'function') {
                return;
            }

            if (typeof e.params !== 'undefined') {
                p = e.params;
            }

            $(e.target)[e.func](p);
        });
    };


    app.init = function () {
        app.$objs.document = $(document);
        app.$objs.body = $('body');

        app.initModules();
        app.bindPlugins();
        app.onInput();
        app.inputPassword();
        app.parsleyButton();

        app.onSubMenu();
        app.onMobileOpener();
        app.onAddList();
        app.onRemoveList();
        app.modals();
        app.onDropdown();
        app.onTableOperation();
        app.onInputCollapsible();
        app.onImportExcel();
        app.onProgress();
        app.onNotification();
        app.onPasswordToggle();
        app.onSelect();
        app.onIPMask();
        app.onButtons();
        app.onTableTooltip();
        app.onJSZip();
        app.onTabs();
        app.onDatepicker();
        app.onFileUpload();
        app.onDynamicModal();
        app.onLoginCookieOperation();
        app.onPreventEmoji();
    };

    app.initModules = function () {
        if (app.modules.length > 0) {
            app.modules.forEach(function (module) {
                if (typeof app[module] !== 'undefined' && !app[module].isInitialized()) {
                    app[module].init();
                }
            });
        }
    };

})(pc);

$(function () {
    pc.init();
});
